import { createContext, useEffect } from "react";
import { useSearchParams } from "react-router-dom";

// project import
import defaultConfig, { Config } from "config";
import useLocalStorage from "hooks/useLocalStorage";

// initial state
const initialState = {
  ...defaultConfig,
  onChangeMenuType: (navType: string) => {
    console.log(navType);
  },
  onChangePresetColor: (presetColor: string) => {
    console.log(presetColor);
  },
  onChangeLocale: (locale: string) => {
    console.log(locale);
  },
  onChangeFontFamily: (fontFamily: string) => {
    console.log(fontFamily);
  },
  onChangeIsInWebview: (isInWebview: boolean) => {
    console.log(isInWebview);
  }
};

const navigatorLang = () => {
  const code = navigator.language.split(/[-_]/)[0];
  const LANGS = ["ar", "de", "en", "es", "fr", "id", "it", "ja", "ko", "nl", "pl", "pt", "ru", "zh-CN", "sv", "th", "tr", "vi", "zh-TW"];

  if (navigator.language === "zh" || navigator.language === "zh-CN") {
    return "zh-CN";
  }

  if (navigator.language === "zh-TW") {
    return "zh-TW";
  }

  return LANGS.indexOf(code) > -1 ? code : "en";
};

// ==============================|| CONFIG CONTEXT & PROVIDER ||============================== //

const ConfigContext = createContext(initialState);

interface ConfigProviderProps {
  children: React.ReactNode;
}

function ConfigProvider({ children }: ConfigProviderProps) {
  const [config, setConfig] = useLocalStorage<Config>("funplus-config", {
    fontFamily: initialState.fontFamily,
    navType: initialState.navType,
    presetColor: initialState.presetColor,
    locale: navigatorLang() || initialState.locale,
    isInWebview: initialState.isInWebview
  });

  const [searchParams] = useSearchParams();
  const isInWebview = searchParams.get("isInWebview");

  useEffect(() => {
    setConfig({
      ...config.current,
      isInWebview: isInWebview === "true"
    });
  }, [isInWebview]);

  const onChangeMenuType = (navType: string) => {
    setConfig({
      ...config.current,
      navType
    });
  };

  const onChangePresetColor = (presetColor: string) => {
    setConfig({
      ...config.current,
      presetColor
    });
  };

  const onChangeLocale = (locale: string) => {
    setConfig({
      ...config.current,
      locale
    });
  };

  const onChangeFontFamily = (fontFamily: string) => {
    setConfig({
      ...config.current,
      fontFamily
    });
  };

  const onChangeIsInWebview = (isInWebview: boolean) => {
    setConfig({
      ...config.current,
      isInWebview
    });
  };

  return (
    <ConfigContext.Provider
      value={{
        ...config.current,
        onChangeMenuType,
        onChangePresetColor,
        onChangeLocale,
        onChangeFontFamily,
        onChangeIsInWebview
      }}
    >
      {children}
    </ConfigContext.Provider>
  );
}

export { ConfigProvider, ConfigContext };
